import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import V2Layout from './views/V2Layout';
import V2HomePage from './views/pages/V2HomePage';
import V2AboutPage from './views/pages/V2AboutPage';
import V2FundPage from './views/pages/V2FundPage';
import V2TeamsPage from './views/pages/V2TeamsPage';
import V2TeamMemberDetail from './views/pages/V2TeamMemberDetail';
import LegacyTeamMemberRedirect from './views/pages/LegacyTeamMemberRedirect';
import V2PortfolioPage from './views/pages/V2PortfolioPage';
import V2NewsPage from './views/pages/V2NewsPage';
import V2ContactPage from './views/pages/V2ContactPage';
import V2LegalDocumentPage from './views/pages/V2LegalDocumentPage';
import { htmlLegacyRoutes, legalDocuments, placeholderLegalPaths, routes } from './models/content';

import './views/styles/v2.css';

export default function V2App() {
  return (
    <V2Layout>
      <Routes>
        <Route path="/" element={<V2HomePage />} />
        <Route path="/about-us" element={<V2AboutPage />} />
        <Route path={routes.fund} element={<V2FundPage />} />
        <Route path="/resilient-fund" element={<Navigate to={routes.fund} replace />} />
        <Route path="/teams" element={<V2TeamsPage />} />
        <Route path="/teams/member" element={<LegacyTeamMemberRedirect />} />
        <Route path="/teams/:slug" element={<V2TeamMemberDetail />} />
        <Route path="/portfolio" element={<V2PortfolioPage />} />
        <Route path="/news-media" element={<V2NewsPage />} />
        <Route path="/contact" element={<V2ContactPage />} />
        <Route
          path={routes.terms}
          element={
            <V2LegalDocumentPage
              title={legalDocuments.terms.title}
              heroTitle={legalDocuments.terms.heroTitle}
              file={legalDocuments.terms.file}
            />
          }
        />
        <Route
          path={routes.privacy}
          element={
            <V2LegalDocumentPage
              title={legalDocuments.privacy.title}
              heroTitle={legalDocuments.privacy.heroTitle}
              file={legalDocuments.privacy.file}
            />
          }
        />
        {placeholderLegalPaths.map((path) => (
          <Route key={path} path={path} element={<Navigate to={routes.home} replace />} />
        ))}
        {Object.entries(htmlLegacyRoutes)
          .filter(([key, to]) => `/${key}` !== to)
          .map(([key, to]) => (
            <Route key={key} path={`/${key}`} element={<Navigate to={to} replace />} />
          ))}
        <Route path="*" element={<Navigate to={routes.home} replace />} />
      </Routes>
    </V2Layout>
  );
}
